import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import { CarrouselCampus } from './components/CarrouselCampus';
import logoImg from '../../static/images/brand/logo-navbar.webp';

export default function CampusPage({ campus }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const waLink = `https://wa.me/${campus.waFooter}?text=${encodeURIComponent(
    'Hola, me gustaria obtener mas informacion sobre Larghetto ' + campus.nombre
  )}`;

  return (
    <div className="bg-black min-h-screen text-white">
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
          <RouterLink to="/">
            <img src={logoImg} alt="Larghetto" className="h-8 w-auto" />
          </RouterLink>
          <div className="hidden md:flex items-center gap-8">
            <RouterLink to="/" className="text-white/60 hover:text-white text-sm transition-colors">
              Inicio
            </RouterLink>
            <RouterLink to="/about" className="text-white/60 hover:text-white text-sm transition-colors">
              Quiénes Somos
            </RouterLink>
          </div>
          <button onClick={() => setMobileMenuOpen(true)} className="md:hidden text-white">
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="relative z-50 md:hidden">
        <div className="fixed inset-0 bg-black/80" />
        <Dialog.Panel className="fixed top-0 right-0 bottom-0 w-64 bg-[#0f0f1a] p-6">
          <div className="flex items-center justify-between mb-8">
            <span className="text-white font-bold">Menú</span>
            <button onClick={() => setMobileMenuOpen(false)}>
              <XMarkIcon className="h-6 w-6 text-white" />
            </button>
          </div>
          <div className="flex flex-col gap-4">
            <RouterLink to="/" onClick={() => setMobileMenuOpen(false)} className="text-white/70 hover:text-white text-sm">
              Inicio
            </RouterLink>
            <RouterLink to="/about" onClick={() => setMobileMenuOpen(false)} className="text-white/70 hover:text-white text-sm">
              Quiénes Somos
            </RouterLink>
          </div>
        </Dialog.Panel>
      </Dialog>

      {/* HERO */}
      <section className="pt-24 pb-16 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="mb-4">
          <RouterLink to="/" className="text-purple-400 text-sm hover:text-purple-300 transition-colors">
            ← Todos los campus
          </RouterLink>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {/* Info */}
          <div className="flex-1">
            <p className="text-purple-400 uppercase tracking-[0.3em] text-xs mb-3">{campus.ciudad}</p>
            <h1 className="text-6xl md:text-8xl font-black text-white leading-none mb-6">{campus.nombre}</h1>
            <p className="text-white/60 text-lg leading-relaxed mb-8 max-w-lg">{campus.descripcion}</p>

            <div className="flex flex-wrap gap-3 mb-10">
              {campus.caracteristicas.map((c) => (
                <span key={c} className="px-4 py-2 rounded-full border border-white/10 text-white/60 text-xs bg-white/5">
                  {c}
                </span>
              ))}
            </div>

            <div className="space-y-2 mb-8">
              <p className="text-white/40 text-sm">{campus.direccion}</p>
              <p className="text-white/40 text-sm">Tel: {campus.telefono}</p>
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-green-600 hover:bg-green-500 text-white font-bold text-sm tracking-wide transition-all duration-300 hover:scale-105"
              >
                <FaWhatsapp size={20} />
                Contáctanos por WhatsApp
              </a>
              <a
                href={campus.linkMaps}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/20 text-white/70 hover:text-white hover:border-white/40 text-sm font-semibold transition-all duration-300"
              >
                <MapPinIcon className="w-5 h-5" />
                Ver en Google Maps
              </a>
            </div>
          </div>

          {/* Carrusel */}
          <div className="w-full lg:w-5/12 rounded-3xl overflow-hidden" style={{ minHeight: '380px' }}>
            <CarrouselCampus images={campus.images} />
          </div>
        </div>
      </section>

      {/* FOOTER FLOTANTE */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        <a href={campus.fb} target="_blank" rel="noreferrer"
          className="w-11 h-11 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-all hover:scale-110 shadow-lg">
          <FaFacebook size={18} />
        </a>
        <a href={campus.ig} target="_blank" rel="noreferrer"
          className="w-11 h-11 rounded-full flex items-center justify-center text-white transition-all hover:scale-110 shadow-lg"
          style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
          <FaInstagram size={18} />
        </a>
        <a href={waLink} target="_blank" rel="noreferrer"
          className="w-11 h-11 rounded-full bg-green-600 hover:bg-green-500 flex items-center justify-center text-white transition-all hover:scale-110 shadow-lg">
          <FaWhatsapp size={18} />
        </a>
      </div>
    </div>
  );
}
